import type {
  IModalContextBindings,
  TModalConfig,
} from '~/interfaces/content/modals';
import {
  type Modals,
  siteModalsStrings,
} from '~/interfaces/dto/general/modals';
import { demoPlayModals } from '~/composables/modals/demo-play.registry';
import { getAuthModals } from '~/composables/modals/auth.registry';
import { getGameModals } from '~/composables/modals/games.registry';
import { getTellerModals } from '~/composables/modals/banking.registry';
import { rgModals } from '~/composables/modals/responsible-gaming.registry';

const useModalContext = (): IModalContextBindings => {
  const siteStore = useSiteStore();
  const currentModal = computed<Modals>(() => siteStore.currentModal as Modals);
  const currentModalAdditionalProps = computed<unknown>(
    () => siteStore.currentModalContext,
  );
  if (!currentModal.value || !siteModalsStrings.includes(currentModal.value))
    return;

  const registry: TModalConfig = {
    ...demoPlayModals,
    ...getAuthModals(),
    ...getGameModals(),
    ...getTellerModals(),
    ...rgModals,
  } as const;

  const config = registry[currentModal.value];
  if (!config && import.meta.dev)
    throw new Error(`Unknown modal: ${currentModal.value}`);
  return {
    ...config,
    ...(currentModalAdditionalProps.value as object),
  };
};

export default useModalContext;
